var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$locale['object']['services-main-banner'])?_c('main',{staticClass:"services-container"},[_c('GlobalMainBanner',{attrs:{"bannerData":_vm.$locale['object']['services-main-banner']}}),_c('ServicesInfoBanner'),_c('ServicesCards'),_c('ServicesHowWeWork'),_c('AboutSlider')],1):_c('Spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }